import con from '../../../../../connection';
var path = '/download';
var download = function (url) { return function () { return ({
    // 操作ログ 出力
    get: function (param) { return con.getFile(url + path, param); },
}); }; };
export default download;
